import styled from 'styled-components';

export default styled.div`
  display: ${props => props.$active ? 'inherit' : 'none'};
  gap: 2rem;
  margin: 2rem 0;
  flex-wrap: wrap;
  position: absolute;
  z-index: 110;
  top: -2rem;
  left: 4.5rem;
  color: ${props => props.$color ? props.$color : '#000'};
  background: ${props => props.$backgroundColor ? props.$backgroundColor : '#fff'};
  border-radius: 0.6rem;
  padding: 2rem;
  white-space: nowrap;

  ${ props => props.$switchListThisStyles }
`;
